// extracted by mini-css-extract-plugin
export default {"accordionList":"accordion-list_accordionList__ZWRtd","expanded":"accordion-list_expanded__aC99A","opacity-transition":"accordion-list_opacity-transition__ivPHO"};